module.exports = __webpack_public_path__ + "img/wall.99998067.svg";